var ie6;
var doctitle;
var map;
var map2 = Array();
var latlng;
var baseIcon;
var newIcon;
var markerOptions;
var infowindow;
var latlng = Array();
var marker = Array();
var text = Array();
var mobilemenu=false;
var mmgenerated=false;
var mmAPI;
var mmenu=false;

var menuWidthCheck = function() {
	if(!mmenu){
		mmenu = $("#nav").clone().attr('id', 'menu');
	}

	if($('#menubutton').is(":visible")){
		if(!mmgenerated){
			$('#menubutton').attr('href', '#menu');

			mmenu.find('.active').addClass('Selected');
			mmenu.mmenu({
				slidingSubmenus: false,
				 extensions: ["pageshadow"]
			}, {
				clone: true
			});

			mmAPI = mmenu.data( "mmenu" );

			mmgenerated=true;
		}
		mobilemenu=true;

	}else if(jQuery('html').hasClass('mm-opened')){
		mmAPI.close();

		mobilemenu=false;


	}else{
		mobilemenu=false;
	}
}


if(document.images){
	p = new Image();
	p.src = "/images/loading.gif";
}

$.fn.preload = function() {
    this.each(function(){
        $('<img/>')[0].src = this;
    });
}

var emailsiteProtect = function(){

	$('span.emailsite').each(function(){
		var word=$(this).attr('data-word');
		var e_a = "to";
		var e_b = $(this).attr('data-eb');
		var e_c = "@";
		var e_d = $(this).attr('data-ed');
		var e_e = "mail";
		var e_f = $(this).attr('data-ef');

		word=(word=='' ? e_d + e_f + e_c + e_b : word);
		word=word.replace(/[\.]/g, '<span class="zerospace"> </span>.').replace(/[@]/g, '@<span class="zerospace"> </span>');

		$(this).replaceWith('<a href="' + e_e + e_a + ':' + e_d + e_f + e_c + e_b + '">'+word+'<' + '/' + 'a>');

	});
};

var postForm = function(formid, url){
	var form=$('#'+formid);

	form.submit(function(event){
		form.addClass('loading');

		$.ajax({
			type: 'POST',
			url: '/inc/'+url,
			data: form.serialize(),
			success: function(response){
				form.html(response);
				form.removeClass('loading');
			}
		});

		event.preventDefault();
	});
};

var postFormChange = function(formid, url, varqs){
	var form=$('#'+formid);

	form.addClass('loading');

	$.ajax({
		type: 'POST',
		url: '/inc/'+url+'?change=1'+varqs,
		data: form.serialize(),
		success: function(response){
			form.html(response);
			form.removeClass('loading');
		}
	});
};

var sliderControl = function(id, index){
	if(index==0 && window.location.hash) {
		var hash = window.location.hash;

		index = $('#'+id+' div').index($(hash));
	}

	jQuery('#'+id).accordion({
		autoHeight: false,
		navigation: false,
		active: index,
		collapsible: true
	});
};

var dynamicItems = function(uldiv, id, file){
	$('#'+uldiv+id+'list a').each(function() {
		$(this).click(function(event){
			did=$(this).attr('rel');
			title=$(this).attr('title');

			new dynamicItem(did, uldiv, id, file, title);
			event.preventDefault();

			$('#'+uldiv+id+'list a').removeClass('active');

			$(this).addClass('active');
		});
	});
};

var dynamicItem = function(did, uldiv, id, file, title){
	var div=$('#'+uldiv+id);
	var url = '/inc/'+file;
	var loading = $('#loading'+id);

	div.fadeTo(0, 0);
	loading.addClass('loading');

	$.ajax({
		type: 'GET',
		url: url,
		data: 'did='+did,
		success: function(response){
			div.html(response);
			div.fadeTo(300, 1);
			loading.removeClass('loading');
			document.title=title+doctitle;
		}
	});
};

var website = function(url){
	newwindow = window.open(url, '_blank','');
	newwindow.focus();
};

var links = function(){
	$('a').each(function() {
		if ($(this).attr('rel')=='popup'){
			$(this).click(function(event){
				new website($(this).attr('href'));
				event.preventDefault();
			});
		}
	});
};

var scrollToDiv = function(element, offsetadjust){
	if(element==0){
		var totalScroll=offset;
	}else{
		var offset = element.offset();
		var totalScroll = (offset.top-offsetadjust);
	}

	var animtime=(totalScroll*.5);
	animtime=(animtime<500 ? 500 : animtime);

	$('body,html').animate({
		scrollTop: totalScroll,
		easing: 'easeOutCubic'
	}, animtime);
};

var mapArtsTrail = function(glatcenter, glngcenter, gzoom, points, numbered){
	var mapOptions = {
		center: new google.maps.LatLng(glatcenter, glngcenter),
		zoom: gzoom,
		scrollwheel: false,
		mapTypeId: google.maps.MapTypeId.ROADMAP
    };
    map = new google.maps.Map(document.getElementById("amap"), mapOptions);

	infowindow = new google.maps.InfoWindow({
		content: "loading..."
	});

	var icon;
	var markerpos;

	for(x=0; x<points.length; x++){
		if(numbered==1 && points[x][5]!=0){
			icon = {
				url: "/images/markers/marker"+points[x][5]+".png"
			};
		}else{
			icon = {};
		}

		markerpos = new google.maps.LatLng(points[x][0], points[x][1]);

		marker[x] = new google.maps.Marker({
			position: markerpos,
			map: map,
			icon: icon
		});

		text[x]='<p>'+(points[x][4]=='' ? '' : points[x][4])+'<strong>'+((numbered==1 && points[x][5]!=0) ? (points[x][5]+'. ') : '')+points[x][2]+'<'+'/strong>'+(points[x][3]=='' ? '' : ('<br />'+points[x][3]))+'<'+'/p>'+(points[x][6]!='' ? ('<p><strong>'+points[x][6]+'<'+'/strong><'+'/p>') : '');
	}

	$mapobj = $('#amap');
	/*$cover = $('<div class="cover"></div>');
	$mapobj.append($cover);
	$cover.on('click', function () {
		$cover.hide();
	});

	$(window).bind("touchstart click", function (e) {
		if (!$mapobj.is(e.target) && $mapobj.has(e.target).length === 0){
			$cover.show();
		}
	});*/
};

function showText(index, gzoom, slide){
	infowindow.setContent(text[index]);
	infowindow.open(map, marker[index]);

	new scrollToDiv($('#amap'), 0);
}

var overlay;
var mapRepo = function(gid){
	var projection = overlay.getProjection();
    var pixel = projection.fromLatLngToContainerPixel(marker.getPosition());

	$("#address"+gid).fadeIn().css({ top:(pixel.y+15), left:(pixel.x-150)});
}

var mapDisplay = function(glatcenter, glngcenter, glat, glng, gzoom, gid){
	var showmap = function(glatcenter, glngcenter, glat, glng, gzoom, gid){
		var mapOptions = {
			center: new google.maps.LatLng(glat, glng),
			zoom: gzoom,
			scrollwheel: false,
			mapTypeId: google.maps.MapTypeId.ROADMAP
        };

        map2[gid] = new google.maps.Map(document.getElementById("amap"+gid), mapOptions);

		var markerpos = new google.maps.LatLng(glat, glng);

		infowindow = new google.maps.InfoWindow({
			content: "loading..."
		});

		marker = new google.maps.Marker({
			position: markerpos,
			map: map2[gid]
		});

		google.maps.event.addListener(map2[gid], "click", function(event) {
			infowindow.close(map2[gid]);
		});

		google.maps.event.addListener(map2[gid], "dragstart", function(event) {
			infowindow.close(map2[gid]);
		});

		google.maps.event.addListener(map2[gid], "zoom_changed", function(event) {
			infowindow.close(map2[gid]);
		});

		google.maps.event.addListener(marker, "click", function(event) {
			infowindow.setContent($("#address"+gid).html());
			infowindow.open(map2[gid], marker);
		});

		infowindow.setContent($("#address"+gid).html());
		infowindow.open(map2[gid], marker);

		$mapobj = $('#amap'+gid);

		/*$cover = $('<div class="cover"></div>');
		$mapobj.append($cover);
		$cover.on('click', function () {
			$cover.hide();
		});

		$(window).bind("touchstart click", function (e) {
			if (!$mapobj.is(e.target) && $mapobj.has(e.target).length === 0){
				$cover.show();
			}
		});*/

	};

	new showmap(glatcenter, glngcenter, glat, glng, gzoom, gid);
};

var linfo = function(){
	var linfoitem;
	$('ul.linfo li.phone').each(function() {
		linfoitem=$(this);
		linfoitem.children('a').click(function(event){
			$(this).hide();

			$(this).parent().children('span').css('display','block');

			event.preventDefault();
		});
	});
};

var lightboxAjax = function(link){
	//alt=$(link).children(0).attr('alt');
	//$.prettyPhoto.open(new Array(link.href),new Array(alt));
};

var clientLogin = function(action){
	var form=$('#loginform');

	form.attr('action', action);
	form.attr('target', '_blank');
	form.unbind('submit');
	form.submit();
};

var popupTip = function(){
	// Use the each() method to gain access to each elements attributes
	var content=Array();
	var popups = $('#calendar div.popup');
	popups.each(function(p, popup){
		content[p]=popup.innerHTML;
	});

	var i=0;

	$('#calendar td.dayevents').each(function(){
		tpos=$(this).attr('class');
		tpos=tpos.replace('dayevents');

		$(this).qtip({
			content: content[i],
			position: {
				corner: tpos
			},
			hide: {
				delay: 200,
				fixed: true
			},
			style: {
				width: 'auto',
				border: {
					width: 1,
					color: '#404041'
				},
				background: '#ebebeb',
				padding: 0
			}
		});

		i++;
	});
};

var votes = function(){
	var voteholder=$('#voteholder');
	$('#vote').click(function(event){
		var id=$(this).attr('data-id');

		voteholder.html('').addClass('loading');

		$.ajax({
			type: 'GET',
			url: '/inc/vote.php?id='+id,
			success: function(response){
				voteholder.html(response);
				voteholder.removeClass('loading');
			}
		});

		event.preventDefault();
	});

};

var fbLikeSend = function(){
	$('.fblikesend').each(function(){
		$(this).html('<fb:like href=\"'+$(this).text()+'\" layout=\"button_count\" font=\"arial\" send=\"false\" show_faces=\"no\"></fb:like>');
		$(this).css('display', 'block');
	});
};

var cycleImages = function(id, ratio, defaultheight){
	$('#'+id).cycle();

	if($(window).width()<940){
		$('#'+id).height($('#'+id).width()*ratio);
	}else{
		$('#'+id).height(defaultheight);
	}

	$(window).resize(function(){
		if($(window).width()<940){
			$('#'+id).height($('#'+id).width()*ratio);
		}else{
			$('#'+id).height(defaultheight);
		}
	});
};

$(document).ready(function(){
	ie6=(($.browser.msie && $.browser.version.substr(0,1)<7) ? 1 : 0);

	var searchfield=$('#search');
	searchfield.focus(function(event){
		if($(this).attr('value')=='Search site for'){
			$(this).attr('value', '');
		}
	});

	searchfield.blur(function(event){
		if($(this).attr('value')==''){
			$(this).attr('value', 'Search site for');
		}
	});

	new emailsiteProtect();

	if(ie6){
		$("a.lightbox, a.lightboxpt, a.lightboxinline, a.lightboxiframe").each(function(){
			$(this).click(function(event){
				if($(this).attr('href').substring(0, 1)!='#'){
					new popup($(this).attr('href'));
					event.preventDefault();
				}
			});
		});

	}else{

		$("a.lightbox, a.lightboxpt").fancybox({arrows: true, mouseWheel: false, fitToView: true, padding: 5, autoSize: true, openEffect: 'none', closeEffect: 'none', type:'image', helpers: {overlay : {locked     : true}}});

		winheight = ($(window).height()-150);

		$("a.lightboxaa").fancybox({arrows: true, mouseWheel: false, fitToView: true, height: winheight, maxWidth: 920, minHeight: winheight, width:'100%', padding: 0, openEffect: 'none', closeEffect: 'none', type:'iframe', helpers: {overlay : {showEarly : true, locked     : true}}});

		/*$("a.lightboxaa").click(function(event){
			event.preventDefault();

			url=$(this).attr('href');

			$.fancybox.open({href: url , arrows: true, mouseWheel: false, fitToView: true, height: winheight, minHeight: winheight, width:920, padding: 5, openEffect: 'none', closeEffect: 'none', type:'iframe'})
		});*/

		$("a.lightboxiframe").fancybox({mouseWheel: false, width:720, height:700, padding: 5, openEffect: 'none', closeEffect: 'none', type:'iframe', beforeShow: function(){
			$(this).height = ($(window).height()-150);
		}});
		$("a.lightboxinline").fancybox({mouseWheel: false, width:920, height:700, padding: 5, openEffect: 'none', closeEffect: 'none', type:'inline'});

		/*$("a[rel^='lightboxinline']").colorbox({inline:true, innerWidth:920, innerHeight:"90%"});
		$("a[rel^='lightboxiframe']").colorbox({iframe:true, innerWidth:720, innerHeight:600});

		$("a[rel^='lightboxshow']").colorbox({href:$(this).attr('data-href'),iframe:true, innerWidth:940, innerHeight:700});*/
	}

	$('#show').trigger('click');

	new menuWidthCheck();

	$(window).resize(function() {
		new menuWidthCheck();

	});
});
